/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "page_head"
};
const _hoisted_2 = {
  class: "max_item_box"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "row_item"
};
const _hoisted_6 = {
  class: "row_item"
};
const _hoisted_7 = {
  class: "row_item"
};
const _hoisted_8 = {
  class: "btns"
};
import leftTree from "@/components/leftTree/index.vue";
import { queryEvaluationTarget, editEvaluationTarget, addEvaluationTarget, deleteEvaluationTarget } from "@/api";
import { nextTick, reactive } from "vue";
import { treeLoadValue, box } from "@sunrise";
import { ElMessage } from "element-plus";
export default {
  __name: 'evaluationCategorySettings',
  setup(__props) {
    const parentList = ref([]);
    const params = reactive({
      targetType: 0,
      targetName: null,
      sorting: null,
      id: null,
      parentCode: null,
      isEdit: false,
      level: 1
    });
    const paramsResize = () => {
      for (const [key, vals] of Object.entries({
        targetType: 0,
        targetName: null,
        sorting: null,
        id: null,
        parentCode: null,
        level: 1,
        isEdit: false
      })) {
        params[key] = vals;
      }
    };
    const event = reactive({
      nodeClick(data, node) {
        // console.log(data, node);
        console.log(node);
        params.targetName = node.label;
        params.sorting = data.sorting;
        params.id = data.id;
        params.parentCode = node.data.parentCode;
        params.level = node.level;
        params.isEdit = true;
      }
    });
    const leftData = ref([]);
    const getLeftData = async targetCode => {
      const {
        code,
        data
      } = await queryEvaluationTarget();
      if (code == "success") {
        leftData.value = [...treeLoadValue(data)];
        if (!!targetCode) {
          setTimeout(() => {
            leftTree_c.value.tree.setCurrentKey(targetCode);
          }, 0);
        }
        console.log(leftData.value, "leftData.value");
      }
    };
    const editTarget = async () => {
      if (!params.isEdit) {
        for (const item of leftData.value) {
          for (const i of item.evaluationTargetListInfoVoList) {
            if (i.targetName == params.targetName) {
              ElMessage.warning("请勿添加相同类别名称！");
              return;
            }
          }
        }
      }
      if (!params.targetName) {
        ElMessage.warning("请填写类别名称！");
        return;
      }
      if (params.sorting == null) {
        ElMessage.warning("请填写序号！");
        return;
      }
      const {
        code,
        data
      } = !!params.id ? await editEvaluationTarget(params) : await addEvaluationTarget(params);
      if (code == "success") {
        ElMessage.success(params.id ? "编辑成功！" : "添加成功！");
        await getLeftData(params.targetCode);
        // setTimeout(() => {
        //   leftTree_c.value.tree.setCurrentKey(params.targetCode, true);
        // }, 0);

        paramsResize();
      }
    };
    getLeftData();
    const leftTree_c = ref(null);
    const parentFn = val => {
      console.log(val);
      paramsResize();
      params.parentCode = val;
      leftTree_c.value.resize();
    };
    const deleteTarget = async () => {
      console.log(params);
      box("你确定删除吗！", async () => {
        const {
          code
        } = await deleteEvaluationTarget({
          id: params.id
        });
        if (code == "success") {
          ElMessage.success("删除成功！");
          paramsResize();
          getLeftData();
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_head_title = _resolveComponent("head-title");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_head_title, {
        title: "评级类别设置"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(leftTree, _mergeProps({
        ref_key: "leftTree_c",
        ref: leftTree_c
      }, {
        att: {
          data: _unref(leftData),
          currentNodeKey: params.parentCode
        },
        event: event
      }), null, 16)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "上级类别：", -1)), _createVNode(_component_el_select, {
        modelValue: params.parentCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.parentCode = $event),
        placeholder: "上级类别",
        size: "large",
        onChange: parentFn,
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(leftData)], item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.targetCode,
            label: item.targetName,
            value: item.targetCode
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "类别名称：", -1)), _createVNode(_component_el_input, {
        modelValue: params.targetName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.targetName = $event)
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_cache[9] || (_cache[9] = _createElementVNode("span", null, "排序：", -1)), _createVNode(_component_el_input_number, {
        modelValue: params.sorting,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.sorting = $event),
        min: 0,
        step: 1,
        "step-strictly": "",
        "controls-position": "right",
        size: "large"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        style: {
          "margin-left": "1rem"
        },
        onClick: _cache[3] || (_cache[3] = $event => params.sorting++)
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("向上", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        onClick: _cache[4] || (_cache[4] = $event => Number(params.sorting) == 0 ? '' : params.sorting--)
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("向下", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        disabled: !params.isEdit,
        onClick: editTarget
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("保存修改", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        disabled: params.isEdit,
        type: "primary",
        size: "large",
        onClick: editTarget
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("添加子类别", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        onClick: deleteTarget
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("删除类别", -1)]))]),
        _: 1
      })])])])]);
    };
  }
};